import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calendar, Clock, Users, Star, UserCog } from 'lucide-react';
import { MeetingLinkButton } from '../sessions/BookingGroupPanel';
import { fmtDate, endTime } from '../../lib/apiError';

const statusBadge = (s) => {
  if (s.booking_status === 'cancelled') return <Badge className="bg-rose-100 text-rose-700 border-rose-300">Cancelled</Badge>;
  if (s.is_completed) return <Badge className="bg-emerald-100 text-emerald-700 border-emerald-300">Completed</Badge>;
  if (s.payment_status === 'awaiting_verification') return <Badge className="bg-amber-100 text-amber-700 border-amber-300">Awaiting payment check</Badge>;
  return <Badge className="bg-sky-100 text-sky-700 border-sky-300">Confirmed</Badge>;
};

const TeacherSessionCard = ({ s, showLink = true }) => (
  <Card className="border-0 shadow-md hover:shadow-lg transition-shadow" data-testid={`teacher-session-${s.id}`}>
    <CardContent className="p-5 flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div className="space-y-2 min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="font-semibold text-lg text-slate-900">{s.subject}</h3>
          {s.chapter && <span className="text-sm text-slate-500">· {s.chapter}</span>}
          {statusBadge(s)}
        </div>
        <div className="flex flex-wrap gap-x-5 gap-y-1 text-sm text-slate-600">
          <span className="flex items-center gap-1.5"><Calendar className="w-4 h-4" />{fmtDate(s.booking_date)}</span>
          <span className="flex items-center gap-1.5"><Clock className="w-4 h-4" />{s.start_time}–{endTime(s.start_time, s.duration_hours)}</span>
          <span className="flex items-center gap-1.5" data-testid={`teacher-session-students-${s.id}`}>
            <Users className="w-4 h-4" />{[s.student_name, ...s.participants].join(', ')}
            {s.group_size > 1 && <span className="text-slate-400">({s.filled}/{s.group_size} places)</span>}
          </span>
          {s.executive_name && <span className="flex items-center gap-1.5"><UserCog className="w-4 h-4" />Exec: {s.executive_name}</span>}
        </div>
        {s.student_rating && (
          <p className="text-sm text-amber-700 flex items-center gap-1"><Star className="w-4 h-4 fill-amber-400 text-amber-400" />{s.student_rating}/5{s.student_review && ` — “${s.student_review}”`}</p>
        )}
      </div>
      {showLink && s.booking_status !== 'cancelled' && (
        s.meeting_link
          ? <MeetingLinkButton link={s.meeting_link} testId={`teacher-meeting-link-${s.id}`} />
          : <span className="text-xs text-slate-500 shrink-0" data-testid={`teacher-link-pending-${s.id}`}>Meeting link not added yet</span>
      )}
    </CardContent>
  </Card>
);

export default TeacherSessionCard;
